// dependency injection config for tabs

export const TAB_STYLE_INJECTION_KEY = 'AMIT-tab-style-injection';
export const TAB_COLOR_INJECTION_KEY = 'AMIT-tab-color-injection';
export const TAB_ACTIVE_NAME_INJECTION_KEY = 'AMIT-tab-active-name-injection';
export const TAB_VISIBILITY_DIRECTIVE_INJECTION_KEY =
  'AMIT-tab-visibility-directive-injection';
export const TAB_ACTIVATE_INJECTION_KEY = 'AMIT-tab-activate-func-injection';
